import { methods, request } from "./base";

const reminderApis = {
  getReminders: async (data?: any) => {
    //const route = `/gfc/reminder/${data.patientReminderId}`;
    const route = "/gfc/reminder";
    return await request({
      method: methods.GET,
      route,
      query_params: data,
      priv: true,
    });
  },
  createReminder: async (data?: any) => {
    const route = "/gfc/reminder";
    return await request({
      method: methods.POST,
      route,
      payload: data,
      priv: true,
    });
  },
  updateReminder: async (data?: any) => {
    const route = `/gfc/reminder`;
    return await request({
      method: methods.PUT,
      route,
      payload: data,
      priv: true,
    });
  },
  deleteReminder: async (data?: any) => {
    const route = `/gfc/reminder/${data.patientReminderId}`;
    return await request({
      method: methods.DELETE,
      route,
      priv: true,
    });
  },
};

export default reminderApis;
